import { useEffect } from "react";
import { useFileStore } from "../store/useFileStore";
import { useDynamicDashboardData } from "../context/dashboardDataContext";
import { getSlug } from "../../../../../utils/getSlug";

const Readme = () => {
    // eslint-disable-next-line no-unused-vars
    const [_, setStore] = useFileStore((store) => store.readmemd);

    const { projectInfo } = useDynamicDashboardData();

    useEffect(() => {
        let value = `<h1 align="center">
  <a href="https://demo.reactadmin.com/bootstrap/${getSlug(
      projectInfo?.projectName
  )}" title="React Admin">${
            projectInfo?.projectName
        } Dashboard Bootstrap version</a>
</h1>

![Sufee admin dashboard template preview](https://colorlib.com/wp/wp-content/uploads/sites/2/sufee-free-modern-admin-dashboard-template.jpg)

is an admin dashboard template designed to be beautiful and simple it's fully responsive. It comes with a large collection of components that will offer you multiple possibilities to create the app that best suits your needs. It can be used to create admin panels, project management systems, web application backends, CMS or CRM.

The product presents a large suite of front-end developer tools that can help you start your project. We built it by thinking about what you actually need in a dashboard.
Admin Bootstrap Dashboard React has multiple handpicked and optimized components . Everything is designed to fit together. As you will be able to see, the React Admin dashboard you can access is a customization of this product.

It comes with 3 filter colors for the top navbar abd sidebar (\`white\`, \`black\`, \`red\`) and an option to have a background image. 4 layout variations (\`vertical\`, \`horizontal\`, \`combo\`, \`dual nav\`) to change the layout design.

-
    <a title="demo-site" href="https://demo.reactadmin.com/bootstrap/${getSlug(
        projectInfo?.projectName
    )}"><strong>Demo Site</strong></a>
    &#x2022;
    <a title="quick-start" href="#quick-start"><strong>Quick Start</strong></a>
    &#x2022;
    <a title="installation" href="#installation"><strong>Installation</strong></a>
    &#x2022;
    <a title="documentation" href="${
        projectInfo.docURL || "#"
    }"><strong>Documentation</strong></a>
    &#x2022;
    <a title="built-with" href="#built-with"><strong>Built With</strong></a>
    &#x2022;
    <a title="built-with" href="#file-structure"><strong>File Structure</strong></a>
    &#x2022;
    <a title="license" href="#license"><strong>License</strong></a>

### Quick Start

Quick start options:

-   Clone the repo:

\`\`\`
git clone https://github.com/reactadmins/bootstrap-${getSlug(
            projectInfo?.projectName
        )}.git.com
\`\`\`

### Installation

#### npm

\`\`\`
  npm install
\`\`\`

run development server

\`\`\`
  npm run dev
\`\`\`

or

#### yarn

\`\`\`
  yarn install
\`\`\`

run development server

\`\`\`
  yarn run dev
\`\`\`

and

#### pnpm

\`\`\`
  pnpm install
\`\`\`

run development server

\`\`\`
  pnpm run dev
\`\`\`

### Built With

-   [React](https://react.dev/)
-   [React-Router-Dom](https://reactrouter.com/en/main)
-   [Vite](https://vitejs.dev/)
-   [Sass](http://sass-lang.com/)
-   [Bootstrap](http://getbootstrap.com/)
-   [React-Bootstrap](https://react-bootstrap.netlify.app/)
-   [React-Bootstrap](https://react-bootstrap.netlify.app/)
-   [React-Entypo](https://cox-auto-kc.github.io/react-entypo/#/)
-   [React-Entypo](https://cox-auto-kc.github.io/react-entypo/#/)
-   [React-Leaflet](https://react-leaflet.js.org/)
-   [React-Google-Maps](https://visgl.github.io/react-google-maps/)
-   [React-Apexcharts](https://apexcharts.com/docs/react-charts/)
-   [React-Chartjs-2](https://apexcharts.com/docs/react-charts/)
-   [Chart.js](https://www.chartjs.org/)
-   [Recharts](https://recharts.org/en-US/)
-   [React-Select](https://react-select.com/home)
-   [Iconify](https://iconify.design/docs/icon-components/react/)
-   [React-Countup](https://use-count-up.vercel.app/)
-   [Peity-React](https://snyk.io/advisor/npm-package/react-peity)

### File Structure

Within the download you'll find the following directories and files:

\`\`\`
React Admin Dashboard Bootstrap

.
├── public
├── src
│   ├── assets
│   │   ├── fonts
│   │   │   └── Nunito-Bold.otf
│   │   ├── image
│   │   ├── scss
│   │   │   ├── navbars
│   │   │   │   ├── Combo.module.scss
│   │   │   │   ├── DualTopNav.module.scss
│   │   │   │   ├── HorizontalNav.module.scss
│   │   │   │   └── VerticalNav.module.scss
│   │   │   ├── AnalyticsStats.module.scss
│   │   │   ├── Authentication.module.scss
│   │   │   ├── Card.module.scss
│   │   │   ├── CardContent.module.scss
│   │   │   ├── DarkModeSwitch.module.scss
│   │   │   ├── Grids.module.scsss
│   │   │   ├── IconStyle.module.scsss
│   │   │   ├── Layouts.module.scsss
│   │   │   ├── Message.module.scsss
│   │   │   ├── MonthlyStats.module.scsss
│   │   │   ├── NavBarBgWrapper.module.scsss
│   │   │   ├── Notification.module.scsss
│   │   │   ├── NotificationStatsCart.module.scsss
│   │   │   ├── OverlayCard.module.scsss
│   │   │   ├── ProfileCard.module.scsss
│   │   │   ├── SearchBar.module.scsss
│   │   │   ├── Sidebar.module.scsss
│   │   │   ├── SidebarBgWrapper.module.scsss
│   │   │   ├── SocialButton.module.scsss
│   │   │   ├── SocialCounter.module.scss.scsss
│   │   │   ├── SocialStats.module.scsss
│   │   │   ├── Stats.module.scsss
│   │   │   ├── StatsCard.module.scsss${
            projectInfo.dashboardType === "free"
                ? ""
                : `│   │   │   ├── StepCircleWizard.module.scsss
│   │   │   ├── StepSquarWizard.module.scsss
│   │   │   ├── StepTabWizard.module.scsss`
        }
│   │   │   ├── Tables.module.scsss${
            projectInfo.dashboardType === "free"
                ? ""
                : `\n│   │   │   ├── Tabs.module.scsss`
        }
│   │   │   ├── Timeline.module.scsss
│   │   │   ├── Traffic.module.scsss
│   │   │   ├── Typography.module.scsss
│   │   │   ├── UesrProfile.module.scsss
│   │   │   ├── variable.scsss
│   │   │   ├── WeatherStats.module.scsss
│   │   │   └── WidgetsCard.module.scsss
│   ├── components
│   │   ├── AnalyticsStats
│   │   │   └── AnalyticsStats.jsx${
            projectInfo.dashboardType === "free"
                ? ""
                : `\n│   │   ├── ApexCharts
│   │   │   ├── AreaChart.jsx
│   │   │   ├── BarChart.jsx
│   │   │   ├── BubbleChart.jsx
│   │   │   ├── CandlestickChart.jsx
│   │   │   ├── ColumnChart.jsx
│   │   │   └── PieChart.jsx`
        }
│   │   ├── Card
│   │   │   └── Card.jsx
│   │   ├── Chartjs
│   │   │   ├── BarChart.jsx
│   │   │   ├── DoughnutChart.jsx
│   │   │   ├── LineChart.jsx
│   │   │   ├── PieChart.jsx
│   │   │   ├── PolarAreaChart.jsx
│   │   │   └── RadarChart.jsx
│   │   ├── DarkModeSwitch
│   │   │   └── DarkModeSwitch.jsx
│   │   ├── DeviceVisitorStats
│   │   │   └── DeviceVisitorStats.jsx
│   │   ├── Download
│   │   │   └── Download.jsx
│   │   ├── DropdownMenu
│   │   │   └── DropdownMenu.jsx
│   │   ├── Earning
│   │   │   └── Earning.jsx
│   │   ├── Icon
│   │   │   ├── Brandico.jsx
│   │   │   ├── CopyButton.jsx
│   │   │   ├── Entypo.jsx
│   │   │   ├── FontAwesome.jsx
│   │   │   ├── Fontelico.jsx
│   │   │   └── Iconviewer.jsx
│   │   ├── LeafletMaps
│   │   │   ├── DarkMatter.jsx
│   │   │   ├── StreetMap.jsx
│   │   │   ├── Voyager.jsx
│   │   │   └── WorldImagery.jsx
│   │   ├── MonthlyStats
│   │   │   └── MonthlyStats.jsx
│   │   ├── Navbars
│   │   │   ├── Message
│   │   │   │   └── Message.jsx
│   │   │   ├── NavbarType
│   │   │   │   ├── Combo.jsx
│   │   │   │   ├── DualTopNav.jsx
│   │   │   │   ├── HorizontalNav.jsx
│   │   │   │   └── VerticalNav.jsx
│   │   │   ├── Notification
│   │   │   │   └── Notification.jsx
│   │   │   ├── UserProfile
│   │   │   │   └── UserProfile.jsx
│   │   │   ├── NavBarBgWrapper.jsx
│   │   │   └── Navbars.jsx
│   │   ├── NotificationStatsCart
│   │   │   └── NotificationStatsCart.jsx
│   │   ├── OverlayCard
│   │   │   └── OverlayCard.jsx
│   │   ├── ProfileCard
│   │   │   └── ProfileCard.jsx
│   │   ├── RealTime
│   │   │   └── RealTime.jsx
│   │   ├── Recharts
│   │   │   ├── AreaRechart.jsx
│   │   │   ├── BarRechart.jsx
│   │   │   ├── LineRechart.jsx
│   │   │   ├── PieRechart.jsx
│   │   │   ├── RechartRadialBar.jsx
│   │   │   └── RechartScatter.jsx
│   │   ├── Revenue
│   │   │   └── Revenue.jsx
│   │   ├── SearchBar
│   │   │   └── SearchBar.jsx
│   │   ├── Sidebar
│   │   │   ├── Sidebar.jsx
│   │   │   ├── SidebarBgWrapper.jsx
│   │   │   └── SidebarMenu.jsx
│   │   ├── SocialButton
│   │   │   └── SocialButton.jsx
│   │   ├── SocialCounter
│   │   │   └── SocialCounter.jsx
│   │   ├── SocialStats
│   │   │   └── SocialStats.jsx
│   │   ├── Stats
│   │   │   ├── Day.jsx
│   │   │   ├── Month.jsx
│   │   │   ├── Stats.jsx
│   │   │   └── Year.jsx
│   │   ├── StatsCard
│   │   │   └── StatsCard.jsx${
            projectInfo.dashboardType === "free"
                ? ""
                : `\n│   │   ├── StepWizards
│   │   │   ├── Page
│   │   │   │   ├── AdditionalInfo.jsx
│   │   │   │   ├── LoggedIn.jsx
│   │   │   │   └── PersonalDetails.jsx
│   │   │   ├── StepCircleWizard.jsx
│   │   │   ├── StepSquarWizard.jsx
│   │   │   └── StepTabWizard.jsx`
        }${
            projectInfo.dashboardType === "free"
                ? ""
                : `│   │   ├── Tab
        │   │   │   └── Tab.jsx`
        }
│   │   ├── Timeline
│   │   │   └── Timeline.jsx
│   │   ├── Traffic
│   │   │   └── Traffic.jsx
│   │   ├── UserStats
│   │   │   └── UserStats.jsx
│   │   ├── WeatherStats
│   │   │   └── WeatherStats.jsx
│   ├── context
│   ├── layouts
│   │   └── Layouts.jsx
│   ├── views
│   │   ├── AdvancedForm.jsx
│   │   ├── Alerts.jsx
│   │   ├── ApexCharts.jsx
│   │   ├── Badges.jsx
│   │   ├── BasicForm.jsx
│   │   ├── Buttons.jsx
│   │   ├── Cards.jsx
│   │   ├── Chartjs.jsx
│   │   ├── Dashboard.jsx
│   │   ├── Error404.jsx
│   │   ├── Error500.jsx
│   │   ├── GoogleMaps.jsx
│   │   ├── Grids.jsx
│   │   ├── Icons.jsx
│   │   ├── LeafletMaps.jsx
│   │   ├── Login.jsx
│   │   ├── Modals.jsx
│   │   ├── progressBars.jsx
│   │   ├── Recharts.jsx
│   │   ├── Register.jsx
│   │   ├── SocialButtons.jsx
│   │   ├── Tables.jsx
│   │   ├── Tabs.jsx
│   │   ├── Typography.jsx
│   │   ├── Widgets.jsx
│   │   └── WizardForm.jsx
│   ├── App.jsx
│   ├── index.scss
│   ├── main.jsx
│   ├── nav.jsx
│   └── routes.jsx
├── vite.config.js
├── README.md
├── package.json
├── index.html
└── .gitignore

\`\`\`

### License

MIT License Copyright (c) 2024 React Admin

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
`;
        setStore({ readmemd: value });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        projectInfo?.projectName,
        projectInfo.docURL,
        projectInfo?.projectName,
        projectInfo.dashboardType,
    ]);

    return null;
};

export default Readme;
